module.exports = __webpack_public_path__ + "assets/img/084920b789c1c66be2e0001e8a7b4163.svg";